import React from 'react';
import ReactDOM from 'react-dom';
import { HashRouter as Router, 
    Route,
    Switch, } from 'react-router-dom'
import App from './Frontend/App';
import SetupApp from './Setup/App';
import registerServiceWorker from './registerServiceWorker';

ReactDOM.render((
    <Router>
        <Switch>
            <Route exact path="/" component={App}/>
            <Route path="/setup" component={SetupApp} />
        </Switch>
    </Router>
), document.getElementById('root'));

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js